import React, { useEffect, useRef, useState, forwardRef } from "react";
import { AutoSizer, Column, InfiniteLoader, Table as VirtualizedTable } from 'react-virtualized';
import 'react-virtualized/styles.css'; // Import default styles
import keyboardEventManager from "../hooks/KeyboardManager";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { ColumnsIcon, SortIcon } from "../utils/Icons";


// <ArrowKeyStepper
//   disabled={true}          // ← This stops all arrow-key handling
//   columnCount={1}          // Usually 1 for a Table
//   rowCount={rowCount}
// ></ArrowKeyStepper>
const Table = forwardRef((props, ref = []) => {
    const {
        controller = "",
        monospace = false,
        columnInteractions = true,
        edit = true,
        showColumnHeaders = true,
        align = "auto",
        small = false,
        medium = false,
        header = false,
        headerClass = "",
        columnHeaderClass = "",
        row_height = 25,
        row_key = "id",
        rowClass = () => { },
        onRowClick = () => { },
        onRowDoubleClick = () => { },
        onLoadMore = () => { },
        next = () => { },
        prev = () => { },
        getStart = () => { },
        getEnd = () => { },
        // width = 918,
        height = 273,
        offset = 380,
        tweak = 30,
        data = [],
        // columns = [],
        route = "",
        no_header_borders = "",
        scrollbar = false,
        scrollindicator = false,
        className = "",
        ch = false,
        cursor = "pointer",
        infinite = false,
        threshold = 20,
        style = {},
        inline = false,
        columns_editable = false,
        fullHeight = false,
        fullWidth = false,
        rowfade = false,
        onSelectedRowClick = () => { },
        emptyMessage = "",
        disable_scroll = false,
        rounded = false,
        scrollToEnd = false, // keep the last row in view when there's no selection to scroll to (e.g. edit={false})
    } = props;




    // const [columns, setColumns] = useState(props.columns);

    const [sc, setSc] = useState("");
    const [cols, setCols] = useState(props.columns);
    const columns = (!columns_editable) ? props.columns : cols;
    const totalWidth = columns.reduce((sum, col) => sum + (Math.ceil(col.width) || 0), 0);
    const width = (fullWidth) ? totalWidth : (props.width) ? props.width : 0;
    const [editing, setEditing] = useState();
    const [wheel, setWheel] = useState(false);
    const current = (wheel) ? {} : props.current;
    const tableRef = useRef(null);
    const wrapperRef = useRef(null);
    const returnRoute = useRef("");
    const columnRefs = ref;
    const [hoveredColumn, setHoveredColumn] = useState(null);
    const selectedIndex = (edit) ? data.findIndex(item => item?.[row_key] === current?.[row_key]) : null;
    const highlightIndex = (edit) ? data.findIndex(item => item?.[row_key] === props.current?.[row_key]) : null;
    const [loadingPrev, setLoadingPrev] = useState(false);
    const [pageDownAlign, setPageDownAlign] = useState(false);

    const visibleRowsRef = useRef({
        startIndex: 0,
        stopIndex: 0
    });

    const scrollTop = useRef(0);

    let _class = "ui-table-wrap";
    if (small) { _class += " small"; }
    if (medium) { _class += " medium"; }
    if (header) { _class += " header"; }
    if (no_header_borders) { _class += " no-header-borders"; }

    const onColumnResize = (!columns_editable) ? props.onColumnResize : (_column, _delta, _width) => {

        if (_column !== selectedColumn) return;
        let updatedColumns;
        const amt = Math.round((_width + _delta));
        setCols(cols => {
            updatedColumns = cols.map(c => {
                if (c.key === selectedColumn) {
                    const minWidth = 20;
                    return {
                        ...c,
                        width: Math.max(amt, minWidth)
                    };
                }
                return c;
            });
            return updatedColumns;
        });
    }




    const onColDoubleClick = (e) => {
        if (typeof props?.onColDoubleClick === "function") {
            props.onColDoubleClick(e);
        }

        if (columns_editable) {
            // do a thing...
        }
    };

    const reorderColumn = (e, f) => {

        if (typeof props?.reorderColumn === "function") {

            props.reorderColumn(e, f);
        }
        if (columns_editable) {
            // do a thing...
        }
    };

    const onContext = (e) => {
        if (typeof props?.onContext === "function") {
            props.onContext(e);
        }
        if (columns_editable) {
            // do a thing...
        }
    };


    const setSelectedColumn = (e) => {
        if (typeof props?.setSelectedColumn === "function") {
            props.setSelectedColumn(e);
        }

        if (columns_editable) {
            setSc(e);
        }

    }
    const selectedColumn = (!columns_editable) ? props.selectedColumn : sc;



    //  const incrementWidth = (delta = chToPx(1, false)) => {
    //     let updatedColumns;

    //     setColumns(cols => {
    //         updatedColumns = cols.map(c => {
    //             if (c.key === selectedColumn) {
    //                 const minWidth = chToPx(c.title.length);
    //                 return {
    //                     ...c,
    //                     width: Math.max(c.width + delta, minWidth)
    //                 };
    //             }
    //             return c;
    //         });
    //         return updatedColumns;
    //     });

    //     clearTimeout(debounceTimer.current);
    //     debounceTimer.current = setTimeout(() => {
    //         purgeColumns(updatedColumns);
    //     }, 300);
    // };



    const removeColumn = () => { }
    const shiftSwap = () => { }
    const drawSwap = () => { }
    const incrementWidth = (delta = 5) => {
        let updatedColumns;
        setCols(cols => {
            updatedColumns = cols.map(c => {
                if (c.key === selectedColumn) {
                    const minWidth = 20;
                    return {
                        ...c,
                        width: Math.max(c.width + delta, minWidth)
                    };
                }
                return c;
            });
            return updatedColumns;
        });

        // clearTimeout(debounceTimer.current);
        // debounceTimer.current = setTimeout(() => {

        // }, 300);
    }
    const decrementWidth = (delta = 5) => incrementWidth(-delta);

    const nextColumn = () => {
        const idx = columns.findIndex(c => c.key === selectedColumn);
        if (idx === -1) return;                     // nothing selected
        const nextIdx = Math.min(idx + 1, columns.length - 1);
        setSelectedColumn(columns[nextIdx].key);
    };

    const prevColumn = () => {
        const idx = columns.findIndex(c => c.key === selectedColumn);
        if (idx === -1) return;
        const prevIdx = Math.max(idx - 1, 0);
        setSelectedColumn(columns[prevIdx].key);
    };

    useEffect(() => {

        if (!columns_editable) { return; }

        const actions = [
            { key: KBD.TAB, action: (e) => { } },
            { key: KBD.SHIFT_TAB, action: (e) => { } },
            { key: KBD.ENTER, action: (e) => { } },
            { key: KBD.D, action: (e) => removeColumn() },
            { key: KBD.ESCAPE, action: () => { window.bm_state.value = returnRoute.current } },
            { key: KBD.SHIFT_ARROW_RIGHT, action: (e) => shiftSwap(false) },
            { key: KBD.SHIFT_ARROW_LEFT, action: (e) => shiftSwap(true) },
            { key: KBD.ARROW_LEFT, action: (e) => prevColumn() },
            { key: KBD.ARROW_RIGHT, action: (e) => nextColumn() },
            { key: KBD.ARROW_UP, action: (e) => drawSwap() },
            { key: KBD.ARROW_DOWN, action: (e) => { } },
            { key: KBD.INSERT, action: (e) => incrementWidth() },
            { key: KBD.DELETE, action: (e) => decrementWidth() },


        ];
        const cleanup = listen(controller, "columns.edit", actions, false, [KBD.TAB, KBD.ENTER]);
        return cleanup;
    }, [selectedColumn, columns])


    const initEdit = () => {
        returnRoute.current = window.bm_state.value;
        window.bm_state.value = "columns.edit"
        setEditing(true);
        setSelectedColumn(columns[0]["key"]);

    }


    const drawColSort = (_text, _key, _colsort) => {

        const {
            current = "",
            callback = () => { }
        } = _colsort;

        const match = (current === _key);
        if (!match) {
            return (<div onClick={() => callback(_key)} className="ui-col-sort">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        } else {
            return (<div onClick={() => callback(_key)} className="ui-col-sort active">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        }
    }



    const handleDragStart = (e, dataKey) => {
        setSelectedColumn(dataKey);
        e.dataTransfer.setData("text/plain", dataKey); // required
    };

    const handleDragOver = (e, dataKey) => {
        e.preventDefault();
        setHoveredColumn(dataKey);
    };

    const handleDragLeave = (dataKey) => {
        if (hoveredColumn === dataKey) setHoveredColumn(null);
    };

    const handleDrop = (e, targetDataKey) => {
        e.preventDefault();

        if (selectedColumn && targetDataKey && selectedColumn !== targetDataKey) {
            reorderColumn(selectedColumn, targetDataKey);
            // call your reorder function here
        }
        setHoveredColumn(null);
    };

    // useEffect(() => {

    //     if (tableRef.current && selectedIndex !== null) {
    //         tableRef.current.scrollToRow(selectedIndex);
    //         tableRef.current.scrollToAlignment = "start";
    //         tableRef.current.recomputeRowHeights();
    //         // don't use - or use a differnt function. onRowClick(data[selectedIndex], null, selectedIndex);
    //     }
    // }, [selectedIndex]);

    const getRowClassName = ({ index }) => {
        if (index === -1) return "ui-table-header-row"; // Header row

        let ret = (index === highlightIndex) ? "ui-row-selected" : "ui-row";

        if (rowfade) {
            return ret + " fade";
        } else {
            return ret;
        }
    };

    const cellRenderer = ({ columnIndex, rowIndex }) => {
        const row = data[rowIndex];


        if (!row) {
            return (
                <div
                    className="td"
                    style={{
                        textAlign: "center",
                        padding: "5px",
                        color: "#999",
                    }}
                >

                </div>
            );
        }

        const col = columns[columnIndex];
        const _row_class = rowClass(row);

        const _stl = {
            width: col?.width ? `${col.width}px` : "auto",
            textAlign: col?.align ? col.align : "right",
            padding: "0px 5px",
            fontFamily: monospace ? "var(--font-mono)" : "inherit",
        };

        let _v = getValueFromRowByKey(row, col?.key);
        if (typeof col.render === "function") {
            _v = col.render(row[col?.key], row);
        }


        if (col?.rtl) {
            return (
                <div className={`td ${_row_class}`} style={_stl}>
                    <div className="rtl-wrap">
                        <span class="rtl-wrap-text">{_v}</span>
                    </div>
                </div>
            )
        }

        return (
            <div className={`td ${_row_class}`} style={_stl}>
                {_v}
            </div>
        );
    };

    const headerRenderer = ({ label, columnData, dataKey, sortBy, sortDirection }) => {

        const { align = "right", colSort = false } = columnData;
        const isSelected = selectedColumn === dataKey;
        const isHovered = hoveredColumn === dataKey;

        let _hovered = "hovered";
        if (isHovered) {
            let _id = columns.findIndex(item => item.key === selectedColumn);
            let _hid = columns.findIndex(item => item.key === hoveredColumn);
            if (_id > _hid) {
                _hovered = "invert-hovered";
            }
        }

        let _stl = {
            fontFamily: (monospace) ? "var(--font-mono)" : "inherit",
            overflow: "hidden"
        }

        return (
            <div
                style={{ ..._stl, position: "relative", "cursor": cursor }}
                onContextMenu={(e) => {
                    e.preventDefault();
                    setSelectedColumn(dataKey);
                    onContext(columnRefs?.current?.[dataKey]);
                }}
                draggable
                onDoubleClick={() => onColDoubleClick(dataKey)}
                ref={(el) =>
                    columnRefs?.current ? (columnRefs.current[dataKey] = el) : null
                }
                onClick={() => { setSelectedColumn(dataKey) }}
                onDragStart={(e) => handleDragStart(e, dataKey)}
                onDragOver={(e) => handleDragOver(e, dataKey)}
                onDragLeave={() => handleDragLeave(dataKey)}
                onDrop={(e) => handleDrop(e, dataKey)}
                className={`ui-column ${align} ${(isSelected && props?.edit) ? (columnInteractions) ? "selected" : "highlighted" : ""} ${isHovered ? _hovered : ""
                    }`}
            >
                <nobr>{(colSort) ? drawColSort(label, dataKey, colSort) : label}</nobr>

                <div
                    onMouseDown={(e) => {
                        e.preventDefault();
                        if (!isSelected || !props?.edit) { return }
                        const startX = e.clientX;

                        const handleMouseMove = (moveEvent) => {
                            const delta = moveEvent.clientX - startX;
                            onColumnResize?.(dataKey, delta, columnData?.width);
                        };

                        const handleMouseUp = () => {
                            window.removeEventListener("mousemove", handleMouseMove);
                            window.removeEventListener("mouseup", handleMouseUp);
                        };

                        window.addEventListener("mousemove", handleMouseMove);
                        window.addEventListener("mouseup", handleMouseUp);
                    }}
                    style={{
                        position: "absolute",
                        top: 0,
                        right: "-10px",
                        width: (isSelected) ? "20px" : "0px",
                        height: "100%",
                        cursor: (props?.edit) ? "col-resize" : "default",
                        zIndex: 2,
                    }}
                />
            </div>
        );
    };

    const getValueFromRowByKey = (_row, _key) => {

        if (!_key) {
            return;
        }
        const keys = _key.split('.');
        let value = _row;
        for (const key of keys) {
            if (value && key in value) {
                value = value[key];
            } else {
                return undefined;
            }
        }
        return value;
    };





    useEffect(() => {


        const visibleTop = wrapperRef.current.scrollTop;
        const visibleBottom = visibleTop + wrapperRef.current.clientHeight - tweak;

        const rowHeight = row_height;
        const wrapperHeight = wrapperRef.current?.clientHeight ?? 0;

        // Number of rows that actually fit
        const rows = Math.max(0, Math.round(wrapperHeight / rowHeight));
        const adjustedRows = Math.max(0, rows - 2);





        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => { setWheel(false); e.preventDefault(); setPageDownAlign(false); e.stopPropagation(); next() } },
            { key: KBD.ARROW_UP, action: (e) => { setWheel(false); e.preventDefault(); setPageDownAlign(false); e.stopPropagation(); prev() } },
            {
                key: KBD.PAGE_DOWN, action: (e) => {
                    setWheel(false);
                    e.preventDefault();
                    e.stopPropagation();
                    const targetIndex = Math.min(
                        visibleRowsRef.current.stopIndex,
                        data.length - 1
                    );

                    if (targetIndex <= selectedIndex) return;

                    setPageDownAlign(true);
                    setScrollToIndexValue(targetIndex);
                    next(targetIndex - selectedIndex);
                }
            },
            {
                key: KBD.PAGE_UP, action: (e) => {
                    setWheel(false);
                    e.preventDefault();
                    e.stopPropagation();

                    const { startIndex, stopIndex } = visibleRowsRef.current;
                    const pageSize = stopIndex - startIndex + 0;

                    const targetIndex = Math.max(0, startIndex - pageSize);

                    if (targetIndex >= selectedIndex) return;

                    setPageDownAlign(true);
                    setScrollToIndexValue(targetIndex);
                    prev(selectedIndex - targetIndex);
                }
            },
            { key: KBD.CTRL_HOME, action: (e) => { setWheel(false); e.preventDefault(); e.stopPropagation(); getStart() } },
            { key: KBD.CTRL_END, action: (e) => { setWheel(false); e.preventDefault(); e.stopPropagation(); getEnd() } },
        ];

        const cleanup = listen(controller, route, actions, (e) => {


            if (infinite) {



                if (!wheel) {
                    setWheel(true);
                }

                if (e.deltaY < 0) {

                    // scrolling up
                    if (scrollTop.current < (row_height)) {

                        setLoadingPrev(data[0][row_key]);
                        onLoadMore(0, 0, true);


                    }
                }
            }

            if (scrollbar) {
                return;
            }
            if (e.deltaY > 0) {
                next();
            } else {
                prev();
            }
        });

        return cleanup;
    }, [selectedIndex, data, tableRef, route, wheel, loadingPrev, props.loading]);


    useEffect(() => {
        if (!props.loading && loadingPrev) {
            setLoadingPrev(false);
        }
    }, [props.loading, loadingPrev]);

    const isRowLoaded = ({ index }) => {
        return !!data[index];
    };

    const loadMoreRows = async ({ startIndex, stopIndex, prepend = false }) => {

        if (props.loading) return;
        if (onLoadMore) {
            await onLoadMore(startIndex, stopIndex, prepend);
        } else {
            console.log(`Load more rows from ${startIndex} to ${stopIndex}`);
        }
    };








    const prevSelectedIndexRef = useRef(selectedIndex);
    const [scrollToIndexValue, setScrollToIndexValue] = useState(undefined);

    useEffect(() => {
        if (selectedIndex !== prevSelectedIndexRef.current) {
            setScrollToIndexValue(selectedIndex);
            prevSelectedIndexRef.current = selectedIndex;
            const timeout = setTimeout(() => setScrollToIndexValue(undefined), 100);
            return () => clearTimeout(timeout);
        }
    }, [selectedIndex]);


    useEffect(() => {
        tableRef.current.scrollToRow(scrollToIndexValue);
    }, [props?.resetPos])

    const drawAuto = (onRowsRendered, registerChild) => {

        return (


            <AutoSizer>
                {({ height, width, index }) => {
                    const fixedColumns = columns.filter(col => !col.grow);
                    const growableColumns = columns.filter(col => col.grow);
                    const fixedTotalWidth = fixedColumns.reduce((sum, col) => sum + (col.width || 0), 0);
                    const growableTotalBase = growableColumns.reduce((sum, col) => sum + (col.width || 0), 0);
                    const totalBaseWidth = fixedTotalWidth + growableTotalBase;
                    const spaceDelta = width - totalBaseWidth;
                    let colWidths = {};

                    if (growableColumns.length > 0) {
                        if (spaceDelta !== 0) {
                            // Distribute delta (positive or negative) proportionally by original widths
                            growableColumns.forEach(col => {
                                const baseWidth = col.width || 0;
                                const growRatio = baseWidth / growableTotalBase;
                                colWidths[col.key] = baseWidth + (spaceDelta * growRatio);
                            });
                        } else {
                            growableColumns.forEach(col => {
                                colWidths[col.key] = col.width || 0;
                            });
                        }
                    }

                    fixedColumns.forEach(col => {
                        colWidths[col.key] = col.width || 0;
                    });

                    return (
                        <>


                            <div style={{ position: "relative", width, height: (emptyMessage && !data?.length) ? height : "0px" }}>
                                <div className={(emptyMessage && !data?.length) ? "empty-table show" : "empty-table"} >
                                    {emptyMessage}
                                </div>
                            </div>


                            <VirtualizedTable
                                ref={(ref) => {
                                    tableRef.current = ref;
                                    if (infinite) {
                                        registerChild(ref);
                                    }
                                }}


                                onScroll={(e) => {

                                    if (infinite) {
                                        scrollTop.current = e.scrollTop
                                    }

                                }}
                                onRowsRendered={(info) => {
                                    visibleRowsRef.current = {
                                        startIndex: info.startIndex,
                                        stopIndex: info.stopIndex
                                    };

                                    if (infinite) {
                                        onRowsRendered(info);
                                    }
                                }}
                                width={width}
                                scrollToAlignment={(loadingPrev || pageDownAlign) ? "start" : align}
                                className={(showColumnHeaders) ? (monospace) ? "mono-table" : "" : (monospace) ? "mono-table nocolumns" : "nocolumns"}
                                scrollToIndex={(loadingPrev) ? data.findIndex(item => item[row_key] === loadingPrev) : (scrollToEnd && scrollToIndexValue === undefined) ? data.length - 1 : scrollToIndexValue}
                                height={height}
                                style={{
                                    // Transparent so the themed container shows below the last row (was hardcoded white)
                                    backgroundColor: 'transparent',
                                    cursor: 'pointer',
                                    pointerEvents: (loadingPrev) ? "none" : "auto",

                                }}
                                headerHeight={showColumnHeaders ? tweak : 0}
                                rowHeight={row_height}
                                // rowCount={(infinite) ? data.length + 1 : data.length} 
                                rowCount={data.length}
                                rowGetter={({ index }) => data[index] || {}}

                                rowClassName={getRowClassName}
                                tabIndex={-1} // Disable native tabIndex to avoid conflicts
                                onRowDoubleClick={({ rowData, rowIndex, event }) => {
                                    onRowDoubleClick(rowData, event, rowIndex)
                                }}
                                onRowClick={({ rowData, rowIndex, event }) => {
                                    setPageDownAlign(false);
                                    setWheel(false);
                                    onRowClick(rowData, event, rowIndex)
                                }

                                }
                            >

                                {columns.map(col => {
                                    const dynamicWidth = colWidths[col.key] || 0;
                                    return (
                                        <Column
                                            columnData={col}
                                            key={col.key}
                                            label={col.title}
                                            dataKey={col.key}
                                            width={dynamicWidth}
                                            cellRenderer={cellRenderer}
                                            headerRenderer={headerRenderer}
                                        />
                                    )
                                })}
                            </VirtualizedTable></>
                    )
                }}
            </AutoSizer>
        )

    }

    const draw = () => {


        if (!infinite) {
            return drawAuto()
        }


        return (
            <InfiniteLoader
                isRowLoaded={isRowLoaded}
                loadMoreRows={loadMoreRows}
                rowCount={data.length + 1}
                threshold={threshold}
            >

                {({ onRowsRendered, registerChild }) => (
                    drawAuto(onRowsRendered, registerChild)
                )}
            </InfiniteLoader>


        )

    }


    const column_class = (inline) ? "ui-table-container inline" : (rounded) ? "ui-table-container rounded" : "ui-table-container";




    return (
        <div
            style={{
                ...style,
                width: width ? `${width}px` : "auto",
                height: fullHeight
                    ? "100%"                                  // override
                    : offset
                        ? `calc(100vh - ${offset}px)`         // existing behavior
                        : `${height}px`,
                minHeight: fullHeight ? 0 : `${height}px`,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden"
            }}
            className={_class + " " + className}
        >



            {header && (
                <div className={"ui-table-header " + headerClass} style={{ position: "relative" }}>
                    {columns_editable && (
                        <div style={{
                            position: "absolute",
                            left: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "25px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                            <a onClick={() => initEdit()}><ColumnsIcon /></a>
                        </div>
                    )}
                    <div style={{ marginLeft: columns_editable ? "20px" : "0px" }}>
                        {header}
                    </div>
                </div>
            )}

            <div
                ref={wrapperRef}
                className={column_class + " " + columnHeaderClass}
                style={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden'
                }}
                tabIndex="0"

            >



                {(scrollbar &&
                    <div className={(scrollindicator) ? (disable_scroll) ? "custom-scroll-container-noscroll" : "custom-scroll-indicator" : "custom-scroll-container"}>
                        {draw()}
                    </div>
                )}

                {(!scrollbar &&
                    draw()
                )}

            </div>

        </div>
    );
});
export default Table;